import { render } from "./TrendFollowing.vue?vue&type=template&id=4c3bce6c&scoped=true"
import script from "./TrendFollowing.vue?vue&type=script&lang=js"
export * from "./TrendFollowing.vue?vue&type=script&lang=js"

import "./TrendFollowing.vue?vue&type=style&index=0&id=4c3bce6c&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3bce6c"]])

export default __exports__